<p-dialog
  styleClass="request-dialog"
  header="Create Request"
  i18n-header="@@sr_creation.page.header.title"
  [modal]="true"
  [(visible)]="visible"
  closeOnEscape="true"
  draggable="false"
  dismissableMask="true"
  resizable="false"
  (onHide)="close()">
  <carehub-service-request-creation (closeEvent)="close()"></carehub-service-request-creation>
</p-dialog>
